import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import { IoIosArrowForward } from "react-icons/io";
import "../../css/WorkFlow.css";
import Header from "../Header/Header";
import Footer from "../Footer/footer";

// ===== MAIN IMAGES =====
import qaImg from "../../../assets/workflow/TestManagement-TestScenario.png";
import projectImg from "../../../assets/workflow/ProjectManagement.png";
import defectImg from "../../../assets/workflow/DefectManagement.png";
import reqImg from "../../../assets/workflow/ProjectManagement-Requirement.png";
import buildImg from "../../../assets/workflow/Management-Build.png";
import releaseImg from "../../../assets/workflow/Release-Management.png";
import collabImg from "../../../assets/workflow/Collaborative-Test.png";
import gitImg from "../../../assets/workflow/git.png";

// ===== QA TEST MANAGEMENT FEATURE IMAGES =====
import exportImg from "../../../assets/workflow/QATestManagement/Export-Made-Easy.jpg";
import teamImg from "../../../assets/workflow/QATestManagement/Manage-Teams-Seamlessly.jpg";

// ===== QA TEST MANAGEMENT ICONS =====
import icon1 from "../../../assets/workflow/QATestManagement/Customizable-Fields.svg";
import icon2 from "../../../assets/workflow/QATestManagement/Save-Reuse-Templates.svg";
import icon3 from "../../../assets/workflow/QATestManagement/Manual-API-Based-Test-Execution.svg";
import icon4 from "../../../assets/workflow/QATestManagement/Custom-test-report.svg";
import icon5 from "../../../assets/workflow/QATestManagement/Requirements-Management.svg";
import icon6 from "../../../assets/workflow/QATestManagement/Test-Case-Management.svg";
import icon7 from "../../../assets/workflow/QATestManagement/Manual-API-Based-Test-Execution.svg";
import icon8 from "../../../assets/workflow/QATestManagement/Automation-Support.svg";

// ===== PROJECT MANAGEMENT ICONS =====
import pmIcon1 from "../../../assets/workflow/Project-Management/End-to-End-Testing-Made-Simple.svg";
import pmIcon2 from "../../../assets/workflow/Project-Management/Built-in-Build-Management.svg";
import pmIcon3 from "../../../assets/workflow/Project-Management/Create-and-Organize-Modules.svg";
import pmIcon4 from "../../../assets/workflow/Project-Management/Team-Management-Made-Easy.svg";

// ===== DEFECT MANAGEMENT IMAGES =====
import defectFeature1 from "../../../assets/workflow/Defect-Images/Seamless-Integration.jpg";
import defectFeature2 from "../../../assets/workflow/Defect-Images/Effortless Collaboration.jpg";
import defectFeature3 from "../../../assets/workflow/Defect-Images/Real-time Testing Insights.jpg";

// ===== DEFECT MANAGEMENT ICONS =====
import defectIcon1 from "../../../assets/workflow/Defect-Images/Information-Rich-Dashboard.svg";
import defectIcon2 from "../../../assets/workflow/Defect-Images/Custom-Defect-Reports.svg";
import defectIcon3 from "../../../assets/workflow/Defect-Images/Flexible-Reporting.svg";

/* ⚠️ NOTE:
   Import ALL remaining icons exactly like your original file paths.
   Do not change names. Only remove spaces if they break build.
*/

const teamData = {
  QATestManagement: {
    title: "Test Management with Full Traceability and Reporting",
    description: (
      <div>
        <h5 >
          Powerful All-in-One QA Management – Powered by FrothAI
        </h5>
        <p className="mb-3 workflow-p">
          <span className="text-primary "> Froth TestOps </span> helps you to
          effortlessly carry out different Quality Assurance activities in an
          integrated way starting from test planning and going through
          execution, defect tracking, reporting, and final approvals. It is a
          product developed for the use of QA teams, developers, and managers
          and offers an easy-to-use interface that helps even the most
          complicated testing activities to be easily understood and checked.
          Many teams think that it is one of the best test management tools for
          businesses as it brings everything into one single, smart platform.
        </p>

        <p>
          <span className="text-primary">FrothAI</span>,<span className="text-primary ms-1">Froth TestOps</span> provides great features
          to the users, which include making smart decisions, auto-suggesting
          test cases, and detecting anomalies at the earliest stage. Do not move
          from one tool to another anymore, as all the tools you need are
          integrated into one powerful system.
        </p>

        <div className="mb-0">
          <ul className="list-unstyled">
            <li className="mb-1">• AI-Powered Suggestions & Risk Detection</li>
            <li className="mb-1">• Manager & Stakeholder Approval Workflows</li>
            <li className="mb-1">
              • End-to-End Visibility with Real-Time Sync
            </li>
          </ul>
        </div>

        <h5>
          Streamlined Test Execution & Tracking
        </h5>
        <p >
          Monitor your testing activities in real time and quickly adapt as
          requirements change. <span className="text-primary"> Froth TestOps </span> simplifies how you execute tests
          and capture results, while AI-enhanced analytics help identify
          recurring defects and potential bottlenecks. Teams are able to cut
          down on manual tasks and speed up their entire testing cycle through
          the use of smart QA workflow automation.
        </p>
        <p >
          Teams can keep on delivering software of high quality—within the time
          frame and budget—by lessening the manual work involved in test
          creation and enhancing traceability.
        </p>

        <h5 >
          Customizable Test Case Management
        </h5>
        <p >
          Every team works differently—and <span className="text-primary"> Froth TestOps </span> lets you define
          reusable components, modular test cases, and templates that reflect
          your Agile or hybrid methodologies.
        </p>
        <p >
          <span className="text-primary">FrothAI</span> can recommend test case structures based on past patterns and
          linked requirements, helping teams scale faster and with consistency.
        </p>

        <h5>
          Collaborative and Scalable QA Process
        </h5>
        <p >
          Collaboration with efficiency. <span className="text-primary"> Froth TestOps </span> supports collaboration
          without any trouble among the teams that are geographically separated.
          You can assign the tasks, specify the roles, and even automate the
          involvement of the stakeholders through the approval workflows thus,
          making sure that QA has ceased to be a siloed process.
        </p>
        <p >
          Furthermore, it has strong integration with Jira and Git tools that
          enable you to have complete visibility of your QA cycle.
        </p>

        <h5 >
          Data-Driven Testing Insights
        </h5>
        <p >
          Make your QA data work for you. <span className="text-primary"> Froth TestOps </span> provides teams with the
          ability to generate a wide range of detailed and customizable reports
          and visualizations by which they can evaluate test coverage, failure
          trends, defect leakage, and so on.
        </p>
        <p>
          By utilizing AI-based insight recommendations, you are empowered to
          make release decisions that are of higher quality and keep on refining
          your QA processes.
        </p>
      </div>
    ),

    image: qaImg,

    cards: [
      {
        icon: icon1,
        title: "Customizable Fields",
        text: (
          <p>
            <span className="text-primary"> Froth TestOps </span> offers an
            interactive, detail-rich dashboard that displays everything you need
            to know about each defect. It simplifies defect tracking and keeps
            your workflow running smoothly.
          </p>
        ),
      },
      {
        icon: icon2,
        title: "Save & Reuse Templates",
        text: (
          <p>
            Create reusable test case templates to maintain consistency across
            projects.
          </p>
        ),
      },
      {
        icon: icon3,
        title: "Field Attachments",
        text: (
          <p>
            Attach relevant documents or screenshots to any test or requirement
            field for better clarity and documentation.
          </p>
        ),
      },
      {
        icon: icon4,
        title: "Custom Test Reports",
        text: (
          <p>
            Get the exact insights you need, when you need them. <span className="text-primary"> Froth TestOps </span>
            supports custom test reports with filters for test status, severity,
            coverage, and even stakeholder comments—delivered in real time.
          </p>
        ),
      },
      {
        icon: icon5,
        title: "Requirements Management",
        text: (
          <p>
            Ensure that requirements and testing are always coordinated.
            Specify, version, and monitor project requirements right in Froth
            TestOps and connect them with the corresponding test cases and
            defects for the complete traceability chain.
          </p>
        ),
      },
      {
        icon: icon6,
        title: "Test Case Management",
        text: (
          <p>
            Whether it is simple smoke tests or elaborate regression scenarios,
            <span className="text-primary"> Froth TestOps </span> helps you to create, combine, and manage the different
            types of test cases in a straightforward manner. Employ tags,
            priorities, and version history to retain transparency throughout
            the life ​‍​‌‍​‍‌​‍​‌‍​‍‌cycle.
          </p>
        ),
      },
      {
        icon: icon7,
        title: "Manual & API-Based Test Execution",
        text: (
          <p>
            If you are a manual tester, or if you are into automation, Froth
            TestOps is just the thing for you. You can perform test cases manual
            or you can connect them to your CI/CD pipeline via REST APIs, thus
            you will be able to automate large-scale test suites in a very
            efficient manner.
          </p>
        ),
      },
      {
        icon: icon8,
        title: "Automation Support",
        text: (
          <p>
            <span className="text-primary"> Froth TestOps </span> with WebdriverIO, thus you can easily record and
            replay your tests without having to write code. In a few clicks only
            you can automate web and mobile test cases—much quicker and simpler
            than before. The AI-powered failure insights help you to locate and
            fix the defects in no time thus making the automation process easy,
            efficient, and scalable for any ​‍​‌‍​‍‌​‍​‌‍​‍‌team.
          </p>
        ),
      },
    ],

    featureCards: [
      {
        image: exportImg,
        title: "Export Made Easy",
        description: (
          <p>
            Exporting your test cases and results shouldn’t be a hassle. <span className="text-primary"> Froth TestOps </span> makes it simple to export testing data to Excel, or
            CSV—quickly and accurately—saving you time and effort.
          </p>
        ),
      },
      {
        image: teamImg,
        title: "Manage Teams Seamlessly",
        description: (
          <p>
            Managing a growing team becomes effortless with <span className="text-primary"> Froth TestOps </span>. Set
            roles, control access, assign responsibilities, and use the built-in
            approval workflow to keep QA aligned with business expectations.
          </p>
        ),
      },
    ],

    accordions: [
      {
        id: "a",
        title: "What is a Test Management Tool?",
        desc: (
          <p>
            Software that helps teams plan, run, and track tests. <span className="text-primary"> Froth TestOps </span>
            centralizes testing and reporting in one platform.
          </p>
        ),
      },
      {
        id: "b",
        title: "Why is Test Management Important?",
        desc: (
          <p>
            It improves quality, speeds up delivery, and keeps teams aligned.
            <span className="text-primary"> Froth TestOps </span> makes testing efficient and insightful.
          </p>
        ),
      },
      {
        id: "c",
        title: "Types of Test Management Tools",
        desc: (
          <p>
            There are manual, automated, and hybrid tools. <span className="text-primary"> Froth TestOps </span>
            supports both manual and automated testing for maximum flexibility
          </p>
        ),
      },
    ],
  },

  ProjectManagement: {
    title: "Testing in Project Management Just Got Easier | Froth TestOps",
    description: (
      <div>
        <h5>
          All-in-One Testing for Project Management
        </h5>
        <p >
          Efficient testing is the main factor of successful projects delivery,
          it is especially true when the time is limited and a few teams are
          involved. <span className="text-primary"> Froth TestOps </span> makes testing easy in your project management
          lifecycle by providing you a robust, in-built project module. Besides
          that, it guarantees a more intelligent execution with the present
          capabilities of modern ai-based automation testing tools for getting
          the results more precise.
        </p>
        <p>
          Every release planning, sprint tracking, or module-wise test case
          organization is basically done in one smart and intuitive workspace.
          By using such integrations as Jira, you can synchronize testing with
          development, this way QA leads, developers, and business stakeholders
          can communicate in a centralized, AI-assisted environment.
        </p>

        <h5>
          Organized Projects. Smarter Testing.
        </h5>
        <p >
          Testing is the main process of the project, it is also a continuous,
          collaborative effort across your project. <span className="text-primary"> Froth TestOps </span> facilitates
          test automation, planning, execution, and defect management within
          well-organized project spaces, thus it empowers teams to perform their
          work with the desired speed and confidence.
        </p>
        <p>
          Irrespective of you operating Agile sprints or waterfall-style
          projects, TestOps will bring the same benefits - clarity, automation,
          and collaboration - in every step you take.
        </p>

        <h5>
          Smart, Centralized QA Management
        </h5>
        <p >
          There is no need anymore for switching between different tools. Froth
          TestOps unites the requirements, test cases, and defects on the same
          platform. Every modification is recorded, every person involved is
          informed, and AI suggestions ensure that issues are resolved at an
          early stage by means of <span className="text-primary"> qa workflow automation </span>  that is simplified.
        </p>
      </div>
    ),

    image: projectImg,

    cards: [
      {
        icon: pmIcon1,
        title: "End-to-End Testing Made Simple",
        text: (
          <p>
            There is no room for confusion when you plan, run, and monitor
            end-to-end testing workflows. <span className="text-primary"> Froth TestOps </span> has a neat and
            user-friendly interface through which you can handle the entire
            testing lifecycle from planning to release without any problem.
          </p>
        ),
      },
      {
        icon: pmIcon2,
        title: "Built-in Build Management",
        text: (
          <p>
            Be a build manager at best. <span className="text-primary"> Froth TestOps </span> facilitates native build
            tracking, this way you can connect builds with test runs, modules,
            or iterations. Put labels on people, keep track of your build
            versions, and get release to QA cycles traceability along with the
            link between them.
          </p>
        ),
      },
      {
        icon: pmIcon3,
        title: "Create and Organize Modules",
        text: (
          <p>
            Stop worrying about how to deal with your huge project and just
            divide it into smaller, more easily manageable modules. Add linking
            of suitable test scenarios and cases, and also represent the linked
            data and requirements—thus your testing will stay not only
            well-organized but also traceable.
          </p>
        ),
      },
      {
        icon: pmIcon4,
        title: "Team Management Made Easy",
        text: (
          <p>
            Adding team members, assigning roles, and regulating permissions in
            line with the project requirements can be achieved with ease. Froth
            TestOps guarantees that every team member—from testers to project
            managers—is aware of his/her role and responsibility.
          </p>
        ),
      },
    ],

    accordions: [
      {
        id: "a",
        title: "What are Project Management Platforms?",
        desc: (
          <p>
            They are software that facilitate work of teams by planning,
            managing, and tracking tasks, timelines, and resources related to
            the project. <span className="text-primary"> Froth TestOps </span> delivers project management integrated
            QA—uniting testing with the rest of the delivery process.
          </p>
        ),
      },
      {
        id: "b",
        title: "Key Features of Project Management Tools",
        desc: (
          <p>
            Indeed. <span className="text-primary"> Froth TestOps </span> embraces a full-fledged project management
            module which is skillfully designed for QA and test coordination. It
            is like having a command centre where you could oversee not only
            various sprints and modules but also test cycles, and user roles
            thus maintaining both control and visibility.
          </p>
        ),
      },
      {
        id: "c",
        title: "Does Froth TestOps Support Project Management?",
        desc: (
          <p>
            <li>Sprint & Release Planning</li>
            <li>Integrated Build Management</li>
            <li>Test & Requirement Linking</li>
            <li>Team & Role Assignment</li>
            <li>Defect Traceability</li>
            <li>Real-Time Dashboards & Reports</li>
            <li>Approval Workflows for QA Sign-Off</li>
          </p>
        ),
      },
    ],
  },

  DefectManagement: {
    title: "TestOps value-add: Built for effective bug and defect tracking:",
    description: (
      <div>
        <h5>
         Froth TestOps streamlined defect management:
        </h5>
        <p >
          Had problems in managing and tracking bugs during the testing phase?
          Defect management system of <span className="text-primary"> Froth TestOps </span> which is streamlined and
          user-friendly is intended for modern QA teams. While carrying out the
          test, use our easy-to-understand issue tracking tools to log and track
          bugs effortlessly. Besides, it harmonizes well with any test case
          tracking tool software so that there is no separation of visibility
          between test cases and defects.
        </p>
        <p>
          <span className="text-primary"> Froth TestOps </span> is the perfect complement to your QA efforts as it
          delivers total transparency and lets you have total control—thus
          enabling the maintenance of software quality during the entire
          development lifecycle. The facility of its clutter-free screen with
          productive workflows is one of the reasons why your team remains
          solution-oriented instead of issue management.
        </p>

        <h5>
          Robust and versatile defect tracking:
        </h5>
        <p >
          No matter whether you have agile or hybrid workflows, you will
          experience the same seamless adaptation of <span className="text-primary"> Froth TestOps </span>. The mistakes
          are recorded immediately, they can be linked to the test cases, and
          you can also classify them depending on their severity or
          influence—this will make it possible to first and foremost attend to
          those issues that are critical and also to assign tests that can
          verify that particular bug fixes.
        </p>

        <h5>Testing Teams Focus:</h5>
        <p >
          Testers constitute the core team whose viewpoints were:
        </p>
        <ul className="list-unstyled mb-3">
          <li className="mb-1">
            • <span className="text-primary"> Froth TestOps </span> lets the members of a testing team put to the fore
            faults on the ground of their urgency and severity.
          </li>
          <li className="mb-1">
            • In addition, they can improve bug reports by adding accurate
            descriptions, statuses, actions as well as timestamps.
          </li>
          <li className="mb-1">
            • At any moment, they are allowed to amend the bug entries for the
            bug status that is most current.
          </li>
          <li className="mb-1">
            • The test suite utilized in the past is accessible through the
            historic test cases linked to the test cases in the past to which it
            has been connected.
          </li>
        </ul>
        <p >
          Aware of every detail, users get to experience maximum convenience
          wherein they are provided with a lifecycle overview of their defects
          that is thorough and exceedingly helpful in them sustaining quality
          and velocity.
        </p>

        <h5>Intelligent, Centralized QA Management</h5>
        <p >
          If you have <span className="text-primary"> Froth TestOps </span>, issue tracking will be an integral part of
          a connected ecosystem where requirements, test cases, and defects
          specification will be gathered in one place. Organize, clarity of
          work, better cooperation, and speedy bug-solving are the perks you get
          here.
        </p>
      </div>
    ),

    image: defectImg,

    cards: [
      {
        icon: defectIcon1,
        title: "Information-Driven Dashboard",
        text: (
          <p>
            One of the nice features that <span className="text-primary"> Froth TestOps </span> offers is an interactive
            and very detailed dashboard that in fact shows all the necessary
            information about the individual defect. Through it, the defect
            tracking becomes simpler and your workflow can continue
            uninterrupted.
          </p>
        ),
      },
      {
        icon: defectIcon2,
        title: "Custom Defect Reports",
        text: "By creating tailored defect reports that are especially designed for the needs of your team, you will be endowed with enhanced command and insight over the QA process.",
      },
      {
        icon: defectIcon3,
        title: "Reporting That Is Flexible",
        text: (
          <p>
            Besides, the defects can be recorded and resued in different modules
            and test cycles. It also helps you to keep a centralized defect log
            from which the reduction of redundancy and the improvement of
            efficiency come as a natural ​‍​‌‍​‍‌​‍​‌‍​‍‌consequence.
          </p>
        ),
      },
    ],

    featureCards: [
      {
        image: defectFeature1,
        title: "Seamless Integration",
        description: (
          <p>
            In addition, <span className="text-primary"> Froth TestOps </span> is compatible with several well-known
            defect tracking instruments, allowing you to continue using your
            current method while being able to take advantage of Froth’s
            efficient issue management without the need for a lengthy and
            detailed training session.
          </p>
        ),
      },
      {
        image: defectFeature2,
        title: "Collaboration without Effort",
        description:
          "Dialogue threads and activity logs are helpful in that they let your entire crew be on the same page, thus cutting down on the time spent on updates and manual follow-ups.",
      },
      {
        image: defectFeature3,
        title: "Testing in Real-time",
        description:
          "The great advantage of such testing is that it provides immediate feedback so in that case, the problem can be solved quickly, the quality preserved, and delivery times met without any trouble.",
      },
    ],
  },

  RequirementManagement: {
    title: "Effective Requirement Management for Agile Teams | Froth TestOps",
    description: (
      <div>
        <h5>
          Agile-Ready Requirement Management — Now Powered by FrothAI
        </h5>
        <p >
          In rapid Agile environments, the requirements change quickly, and the
          misalignment between QA and development can hinder the progress. Froth
          TestOps is designed to help the team handle this complicated issue by
          a smart and integrated Requirement Management module that facilitates
          understanding, trace ability, and speed. Being created as a
          sophisticated <span className="text-primary">AI-powered requirement management tool </span>, it not only
          helps to maintain transparency throughout the Agile lifecycle but also
          ensures that the team members are on the same page at all times.
        </p>
        <p >
          Work with requirements in the easiest way possible by either creating
          them from scratch or importing them. Divide them into epics or user
          stories and directly connect them to test cases and defects for the
          complete illustration. Monitor the changes, lessen the communication
          silos, and align everyone from the story grooming to the sprint
          delivery.
        </p>

        <h5>
          Introducing FrothAI: From Requirement to Test in One Click
        </h5>
        <p >
          Eliminate the writing of test cases by hand. Using FrothAI, you may
          very quickly generate test cases and scenarios from unstructured
          requirements with the help of cutting-edge AI models. Just give a
          requirements and let FrothAI to recommend structured test scenarios
          which can be linked, edited, and assigned directly, without any
          intermediate steps.
        </p>

        <ul className="list-unstyled">
          <li className="mb-1">• AI-generated test cases from user stories</li>
          <li className="mb-1">• Rapid test coverage without manual effort</li>
          <li className="mb-1">• Consistency and reusability across sprints</li>
        </ul>
      </div>
    ),
    image: reqImg,

    accordions: [
      {
        id: "a",
        title: "Requirement Traceability",
        desc: (
          <p>
            Provide coverages that are total and be responsible for them. In
            here with <span className="text-primary"> Froth TestOps </span> you may associate each and every one of your
            requirements with the respective test cases and defects thereby
            creating an overall summary of what was built, tested, and failed -
            all in one place.
          </p>
        ),
      },
      {
        id: "b",
        title: "Import & Organize",
        desc: "Do you want to import requirements from your present systems or spreadsheets? Or maybe create new ones in a moment? Sort them by category, sprint, or team, thus making sure that your backlog is always tidy, easy to find, and ready for the next step.",
      },
      {
        id: "c",
        title: "Align Change Management",
        desc: (
          <p>
            The requirements modify during the current sprint? That is not a
            trouble. <span className="text-primary"> Froth TestOps </span> allow you to simplily update, reassign, and
            realign requirements with the test cases and defects that come from
            downstream-ensuring that your QA process is always handy.
          </p>
        ),
      },
    ],
  },

  BuildManagement: {
    title: "Simplify Build Management with Froth TestOps",
    description: (
      <div>
        <p >
          Track Changes Effortlessly with Powerful Build Management Tools.
        </p>
        <p >
          By automating builds and tracking changes efficiently, <span className="text-primary"> Froth TestOps </span>
          streamlines your build management process. Thus, it helps your team to
          deliver high-quality software at a much faster pace.
        </p>

        <h5>
          Smarter Software Build Management
        </h5>
        <p >
          Development without a correct build management solution may become
          fragmented and prone to errors. <span className="text-primary"> Froth TestOps </span> takes care of the
          management process, thus, it is easier to handle builds, check
          changes, and even guarantee the quality of releases at every stage.
        </p>
        <p >
          Seamlessly integrating with popular CI tools, <span className="text-primary"> Froth TestOps </span> supports a
          fully optimized development pipeline—enabling smooth collaboration,
          rapid iterations, and dependable releases.
        </p>

        <h5>
          Track Every Change During the Build Process
        </h5>
        <p >
          Don't lose track of the changes in your build operations with Froth
          TestOps. Changes that have been tracked can be easily documented,
          managed, and analyzed within your build workflow. Our solution is
          compatible with your preferred testing tools and frameworks—so that
          you can run automated tests at a high speed and with confidence, thus,
          ensuring that every build is up to standard.
        </p>

        <h5>
          Link Bugs and Test Executions to Builds
        </h5>
        <p >
          With <span className="text-primary"> Froth TestOps </span>, it is possible to associate bugs and test
          executions directly with single builds. This facilitates your team in
          issue tracing to the correct release and also confirms that the tests
          that are most important are the ones executed before any
          deployment—thus, giving you the guarantee that nothing escapes your
          attention.
        </p>

        <h5>
          Automate Test Execution During Builds Work Perfection with  <span className="text-primary"> Froth TestOps </span>
        </h5>
        <p >
          Control, manage, and schedule the per-build test executions that you
          want to perform, in a very simple manner. <span className="text-primary"> Froth TestOps </span> allows you to
          specify and automate the test runs for each build, thus, if there is
          any problem, it will be detected at the earliest stage of the release,
          and it will be quick and efficient.
        </p>

        <h5>
          Take Control with  <span className="text-primary"> Froth TestOps </span>
        </h5>
        <p>
          Discover the wide range of build and test management features that are
          available through <span className="text-primary"> Froth TestOps </span>. They provide increased insight,
          tighter control, and faster delivery throughout your software
          development lifecycle.
        </p>
      </div>
    ),
    image: buildImg,

    accordions: [
      {
        id: "a",
        title: "What is Build Management?",
        desc: (
          <p>
            Build management is a process that automates building, testing, and
            deployment of software. <span className="text-primary"> Froth TestOps </span> is a multi-platform tool that
            integrates with CI/CD tools and also offers real-time build status
            updates.
          </p>
        ),
      },
      {
        id: "b",
        title: "Why is Build Management Important?",
        desc: (
          <p>
            The primary function of build management is to allow software
            releases to be done on time and of good quality. <span className="text-primary"> Froth TestOps </span> makes
            the whole process of building simple so that teams would have the
            stamina to think of and deliver better products at a quicker pace.
          </p>
        ),
      },
      {
        id: "c",
        title: "Why is a Build in SDLC?",
        desc: (
          <p>
            In the SDLC, a build refers to a version of the software that has
            been compiled and is ready for testing or release. With the help of
            <span className="text-primary"> Froth TestOps </span>, managing builds becomes effortless, thereby
            increasing the speed and quality of the entire development
            ​‍​‌‍​‍‌​‍​‌‍​‍‌cycle.
          </p>
        ),
      },
    ],
  },

  Integrations: {
    title: "Seamless Integrations for a Smarter Workflow",
    description: (
      <div>
        <p >
          <span className="text-primary"> Froth TestOps </span> works perfectly with the tools you already have in
          place. It integrates defect management systems, source code
          repositories, CI/CD pipelines, and device farms to help your
          automation flow smoothly in any environment. By means of test
          management tool integration that is strong, issue trackers may be
          linked, builds managed, and tests run on different devices - desktops,
          smartphones, or tablets - without losing the flow and from a single
          platform.
        </p>
        <p >
          You are able to automate boring tasks, keep track of changes live, and
          be certain that every release meets your quality standards. Froth
          TestOps is the one which assures that your operations are not
          interrupted, your data is synchronized, and your team is in control
          irrespective of whether you are testing on the latest OS, fixing the
          bug in your tracker, or getting the fresh code from your repository.
        </p>

        <h5>
          Reasons why teams opt for  Froth TestOps :
        </h5>
        <ul className="">
          <li className="mb-1">
            <strong>Effortless Connectivity</strong> – Top defect trackers, source code
            management tools, CI/CD platforms, and device farms can be connected
            effortlessly.
          </li>
          <li className="mb-1">
            <strong>End-to-End Visibility</strong> – All the updates from the tools are
            available through a single point which leaves nothing outside
            consideration.
          </li>
          <li className="mb-1">
            <strong>Faster, Confident Releases</strong> – By removing bottlenecks through
            workflow automation it becomes possible to release high-quality
            software rapidly.
          </li>
        </ul>
      </div>
    ),
    image: gitImg,
  },

  ReleaseManagement: {
    title: "Efficient Release Management for High-Performing Software Teams",
    description: (
      <div>
        <p >
          The management of different releases can be very confusing. <span className="text-primary">Froth TestOps </span> puts you in charge of the entire release process with features
          that range from coordinating builds with scheduled release dates to
          handling project requirements, test plans, and approvals all in one
          consolidated platform. Being one of the most powerful release
          management tools, it allows you to prepare each phase of your release,
          allocate the tasks, and monitor the progress through the latest
          updates at any time.
          <br />
          Our Release Management module allows you to set up and handle
          different builds easily while linking test cases and issues to the
          correct releases. This, in turn, allows you to develop different
          versions simultaneously without the risk of crossover or getting mixed
          up.
        </p>
        <p >
          Prepare each phase of your release, allocate the tasks, and monitor
          the progress through the latest updates at any time. Get the approval
          of all the stakeholders with the existing confirmation workflows so
          that the requirements can be validated and the test plans can be
          signed off before their execution. Thanks to the automated scheduling,
          progress tracking, and centralized communication, the transition from
          planning to production can be done with fewer delays, better quality,
          and complete confidence.
        </p>
        <p>
          Conduct tests, monitor progress, and generate reports for each build
          separately — thus, keeping your projects structured and your releases
          going as planned, without fail
        </p>
      </div>
    ),
    image: releaseImg,
  },

  CollaborativeTestDesign: {
    title: "Collaborative Test Design",
    description: (
      <div>
        <p >
          By using <span className="text-primary"> Froth TestOps </span>, handling the entire QA workflow becomes very
          simple and thus one does not need to keep changing between mails,
          tools, or spreadsheets. Initiate your test cycles by planning and
          organising, creating and tracking test plans and managing approvals
          and sign-offs on the platform itself.
        </p>
        <p >
          Discussions, updates, and feedback in a common workspace are the ways
          by which developers, testers, and business teams can jointly work.
          Generate automated reports, share them instantly for verification, and
          maintain a clear audit trail of every decision made. <span className="text-primary"> Froth TestOps </span> is
          a tool that helps everyone to be on the same page, aware, and
          quality-ready — together.
        </p>

      
        <ul >
          
          <li className="mb-1 fw-bold list-unstyled">
            Review & Approve with Ease :
          </li>
          <li className="mb-1 ">
            <span className="fw-bold"> Effortless Connectivity –</span> Inspection, feedback, and approval of
            test managers are facilitated by enabling them to do all these
            actions in the same platform, which is before the test cases are
            executed.
          </li>
          <li className="mb-1">
            <span className="fw-bold"> Streamline Issue Handoffs –</span> Tester should be given opportunities
            of logging defects and assigning them directly to developers who
            will then quickly do the necessary fixes and there will be no chance
            of misunderstanding in communication.
          </li>
          <li className="mb-1">
            <span className="fw-bold">Stay in the Loop –</span> Customize your notifications so that every
            stakeholder gets an update immediately when tasks are accomplished
            or there are changes.
          </li>
        </ul>
        <p className="mb-0">
          Collaborate without any flaws, do your testing work effectively, and
          release better software — together.
        </p>
      </div>
    ),

    image: collabImg,
  },
};

const WorkFlow = () => {
  const [selectedTeam, setSelectedTeam] = useState("QATestManagement");
  const [openId, setOpenId] = useState(null);
  const location = useLocation();
  const title = "QA Workflow Automation for Faster Testing and Better QA";
  const description =
    "Simplify and automate testing with our qa workflow automation tools, boosting testing speed, accuracy, and overall efficiency in software quality.";

  const data = teamData[selectedTeam];

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <>
      <Helmet>
        <title>QA Workflow Automation for Faster Testing and Better QA</title>

        <meta
          name="description"
          content="Simplify and automate testing with our qa workflow automation tools, boosting testing speed, accuracy, and overall efficiency in software quality."
        />

        <meta name="keywords" content="qa workflow automation" />

        <link rel="canonical" href="https://frothtestops.com/contact" />

        {/* Open Graph Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://frothtestops.com${location.pathname}`}
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>
      <div
        className={`fd-main-wrappers ${location.pathname !== "/" ? "page-padding" : ""}`}
      >
        <Header />
        <div className="workflow-container">
          <h1 className="workflow-title">Solution</h1>

          <div className="workflow-grid">
            {/* LEFT SIDEBAR */}
            <div className="workflow-sidebar">
              <h2>By WorkFlow</h2>

              {Object.keys(teamData).map((team) => (
                <button
                  key={team}
                  onClick={() => setSelectedTeam(team)}
                  className={`workflow-btn ${selectedTeam === team ? "active" : ""}`}
                >
                  {team}
                  <IoIosArrowForward />
                </button>
              ))}
            </div>

            {/* RIGHT CONTENT */}
            <div className="workflow-content">
              <div>
                <h2>{data.title}</h2>
                <div>{data.description}</div>
              </div>

              <div className="workflow-image">
                <img src={data.image} alt={selectedTeam} />
              </div>

              {/* FEATURE CARDS */}
              {data.featureCards && (
                <div className="workflow-feature-cards">
                  {data.featureCards.map((card, i) => (
                    <div key={i} className="workflow-feature-card">
                      <img src={card.image} alt="" />
                      <div className="cardtexts">
                        <h5>{card.title}</h5>
                        <p>{card.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* CARDS */}
              {data.cards && (
                <div className="workflow-cards">
                  {data.cards.map((card, i) => (
                    <div key={i} className="workflow-card">
                      <img src={card.icon} alt="" />
                      <h4>{card.title}</h4>
                      <div>{card.text}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* ACCORDION */}
              {data.accordions && (
                <div className="workflow-accordion">
                  {data.accordions.map((item) => {
                    const isOpen = openId === item.id;

                    return (
                      <div key={item.id} className="workflow-accordion-item">
                        <button
                          onClick={() => toggleAccordion(item.id)}
                          className="workflow-accordion-header"
                        >
                          {item.title}
                          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
                        </button>

                        {isOpen && (
                          <div className="workflow-accordion-body">
                            {item.desc}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default WorkFlow;
